import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Alert from 'react-bootstrap/Alert';
import { useTranslation } from '../i18n';

interface PaymentSuccessModalProps {
  show: boolean;
  onClose: () => void;
  onContinue?: () => void;
  onViewCredits?: () => void;
  creditAmount?: number;
  status?: 'success' | 'pending';
}

const PaymentSuccessModal: React.FC<PaymentSuccessModalProps> = ({ 
  show, 
  onClose, 
  onContinue,
  onViewCredits,
  creditAmount,
  status = 'success'
}) => {
  const { t } = useTranslation();
  const handleContinue = () => {
    if (onContinue) {
      onContinue();
    }
    onClose();
  };

  const handleViewCredits = () => {
    if (onViewCredits) {
      onViewCredits();
    }
    onClose();
  };

  const isPending = status === 'pending';
  
  return (
    <Modal show={show} onHide={onClose} centered size="lg">
      <Modal.Body className="text-center p-5">
        <div className="mb-4">
          <i className={`bi ${isPending ? 'bi-hourglass-split text-warning' : 'bi-check-circle-fill text-success'}`} style={{ fontSize: '4rem' }}></i>
        </div>
        
        <h2 className={`${isPending ? 'text-warning' : 'text-success'} mb-3`}>
          {isPending ? t('payment.processing_title') : t('payment.success_title')}
        </h2>
        
        <Alert variant={isPending ? 'warning' : 'success'} className="mb-4">
          <Alert.Heading>
            {isPending ? t('payment.transaction_verifying') : t('payment.thank_you')}
          </Alert.Heading>
          <p className="mb-0">
            {isPending ? (
              <>
                {t('payment.payment_processing')}
                {creditAmount && (
                  <>
                    <strong> {t('payment.credits_will_be_added', { creditAmount: creditAmount.toString() })}</strong>
                  </>
                )}
                {!creditAmount && ` ${t('payment.credits_auto_added')}`}
                {' '}{t('payment.verification_email')}
              </>
            ) : (
              <>
                {t('payment.payment_processed')}
                {creditAmount && (
                  <strong> {t('payment.credits_added_amount', { creditAmount: creditAmount.toString() })}</strong>
                )}
                {!creditAmount && ` ${t('payment.credits_added')}`}
                {' '}{t('payment.credits_ready')}
              </>
            )}
          </p>
        </Alert>

        <div className="d-grid gap-2">
          <button 
            className="btn btn-primary btn-lg"
            onClick={handleContinue}
          >
            {t('payment.continue')}
          </button>
          <button 
            className="btn btn-outline-secondary"
            onClick={handleViewCredits}
          >
            {t('payment.view_credits')}
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default PaymentSuccessModal;